export default __webpack_public_path__ + "static/media/profile-pic(3).85e856e6.png";